import React, { FC, Fragment, useEffect } from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { isExpectedErrorMessage, isGatewayErrorMessage } from './error-reporting/expected-errors';

type ErrorFallbackProps = {
    error: any;
    resetErrorBoundary: () => void;
};
const ErrorFallback: FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }: ErrorFallbackProps) => {
    const { t: translate } = useTranslation(['common']);
    let shouldShowError = false;
    let shouldShowGatewayError = false;

    if (!isExpectedErrorMessage(error?.message)) {
        shouldShowError = true;
    }
    if (isGatewayErrorMessage(error?.message)) {
        shouldShowGatewayError = true;
    }

    useEffect(() => {
        if (shouldShowError || shouldShowGatewayError) {
            localStorage.clear();
        }
    }, []);

    return (
        <Fragment>
            {shouldShowGatewayError ? (
                <div
                    role="alert"
                    style={{
                        maxWidth: 700,
                        fontFamily: 'sans-serif',
                        margin: 'auto',
                        marginTop: 80,
                    }}
                >
                    <Alert severity="info">
                        <AlertTitle>
                            <h1 style={{ marginTop: 0 }}>{translate('GATEWAY_ERROR_PAGE_TITLE')}</h1>
                        </AlertTitle>
                        <Box mb={2}>{translate('GATEWAY_ERROR_PAGE_CONTENT')}</Box>
                        <Button
                            variant="contained"
                            onClick={() => {
                                resetErrorBoundary();
                                window.location.reload();
                            }}
                        >
                            {translate('GATEWAY_ERROR_PAGE_RELOAD')}
                        </Button>
                    </Alert>
                </div>
            ) : undefined}
            {shouldShowError ? (
                <div
                    role="alert"
                    style={{
                        maxWidth: 700,
                        fontFamily: 'sans-serif',
                        margin: 'auto',
                        marginTop: 80,
                    }}
                >
                    <Alert severity="error">
                        <AlertTitle>
                            <h1 style={{ marginTop: 0 }}>{translate('ERROR_PAGE_TITLE')}</h1>
                        </AlertTitle>
                        <Box mb={2}>{translate('ERROR_PAGE_CONTENT')}</Box>
                        <Button
                            variant="contained"
                            onClick={() => {
                                resetErrorBoundary();
                                window.location.href = document.referrer;
                            }}
                        >
                            {translate('ERROR_PAGE_RELOAD')}
                        </Button>
                    </Alert>
                </div>
            ) : undefined}
        </Fragment>
    );
};

export default ErrorFallback;
